import { Menu } from 'antd'
import { SyncOutlined, TeamOutlined, AppstoreOutlined, FundOutlined, DatabaseOutlined, AuditOutlined } from '@ant-design/icons'
import { useLocation, useMatches, useNavigate } from 'react-router-dom'

const menuItems = [
    { key: 'pool', icon: <AppstoreOutlined /> , label: '股票池' },
//   { key: '/config', icon: <SettingOutlined />, label: '风格配置' },
    { key: 'managers', icon: <TeamOutlined />, label: '基金经理' },
    { key: 'backtests', icon: <SyncOutlined />, label: '投资策略回测' },
    { key: 'asset-mgmt', icon: <FundOutlined />, label: '资产管理' },
    { key: 'stock-kb', icon: <DatabaseOutlined />, label: '个股知识库' },
    { key: 'review', icon: <AuditOutlined />, label: '投资审核' },
]

function getMatchedMenuKey(pathname: string) {
    const pathnameSegments = pathname.split('/').filter(Boolean)

    return menuItems.find((item) => {
        const itemSegments = item.key?.split('/').filter(Boolean) ?? []

        if (itemSegments.length > pathnameSegments.length) {
            return false
        }

        return itemSegments.every((segment, index) => pathnameSegments[index] === segment)
    })?.key
}

type RouteHandle = {
    key?: string
}

export default function MenuCenter() {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const matches = useMatches()
    
    const selectedKey = [...matches]
        .reverse()
        .map((match) => (match.handle as RouteHandle | undefined)?.key)
        .find((key): key is string => Boolean(key))
        ?? getMatchedMenuKey(pathname)

    return (
        <Menu
            theme="dark"
            mode="inline"
            selectedKeys={selectedKey ? [selectedKey] : []}
            items={menuItems}
            inlineCollapsed={true}
            onClick={({ key }) => navigate(key)}
            style={{ borderRight: 0, marginTop: 4, background: '#0c1222' }}
        />
    )
}
